/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
//
try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
} catch (e) {
}
//
require('bootstrap');
// require('./home-swiper'); // products swiper
require('./home-products2');
require('./home-testimonials-swiper');
const scrollTo = el => {
    if (el) {
        const top = window.scrollY + el.getBoundingClientRect().top;
        window.scrollTo({top: top, behavior: "smooth"})
    }
}

window.helpers = require('./../helpers');

$(document).ready(function () {
    // clones to empty modals when open
    var $homeLoginModal = $('#home-login-modal').html();
    var $homeRegisterModal = $('#home-register-modal').html();
    var $homePasswordModal = $('#home-password-modal').html();
    var $homeVerifyModal = $('#home-verify-modal').html();

    window.helpers.setCookie('affBBtest', '11', 1)
    $(document).on('click', '.btn-open-login-modal', function () {
        $('.modal').modal('hide');
        $('#home-login-modal').html($homeLoginModal).modal('show');
    });
    $(document).on('click', '.btn-open-register-modal', function () {
        $('.modal').modal('hide');
        $('#home-register-modal').html($homeRegisterModal).modal('show');
    });
    $(document).on('click', '.btn-open-password-modal', function () {
        $('.modal').modal('hide');
        $('#home-password-modal').html($homePasswordModal).modal('show');
    });
    $(document).on('click', '.btn-open-verify-modal', function () {
        $('.modal').modal('hide');
        $('#home-verify-modal').html($homeVerifyModal).modal('show');
    });
    $(document).on('click', '.btn-open-terms-modal', function () {
        $('.modal').modal('hide');
        $('#home-terms-modal').modal('show');
    });
    // reopen to leave input in place
    $(document).on('click', '.btn-reopen-register-modal', function () {
        $('.modal').modal('hide');
        $('#home-register-modal').modal('show');
    });

    $(document).on('click', '#btn-accept-terms', function () {
        const getTermsInput = $('input[name=terms]');
        $('.modal').modal('hide');
        $('#home-register-modal').modal('show');
        if (getTermsInput.length && !getTermsInput[0].checked) {
            getTermsInput.click()
        }
    });

    $(document).on('submit', '#formLogin', function (e) {
        submitAuthForm('#formLogin', '#home-login-modal .response-container', '#auth', '#login-redirect-container')
        return false;
    });

    $(document).on('submit', '#formRegister', function () {
        submitAuthForm('#formRegister', '#home-register-modal .response-container', '#register', '#register-redirect-container');
        return false;
    });

    $(document).on('submit', '#formResendVerification', function () {
        submitAuthForm('#formResendVerification', '.authModalRegister .response-container', '#resend-verification-btn');
        return false;
    });

    $(document).on('submit', '#formPassword', function () {
        submitAuthForm('#formPassword', '#home-password-modal .response-container', '#password-link', '#password-redirect-container');
        return false;
    });

    // if(window.location.hash) {
    //     scrollTo(document.querySelector(window.location.hash))
    // }
    $('.btn-top-white').click(function () {
        scrollTo(document.getElementById($(this).data('section-target')))
    });

    setSectionSizes();

    $(window).resize(function () {
        setSectionSizes();
    });

    function setSectionSizes() {
        var $windowWidth = $(window).width();
        var $windowHeight = $(window).height();
        if ($windowWidth > 1300) {
            $('#section-welcome').css('height', $windowWidth * 0.38 + 100)
        } else if ($windowWidth > 780) {
            $('#section-welcome').css('height', $windowWidth * 0.44 + 100)
        } else {
            $('#section-welcome').css('height', $windowWidth * 1.1627)
        }
    }

    $(window).scroll(function () {
        if ($('#section-commission #commission-values').isInViewport()) {
            $('.commission-text-bg1').removeClass('slide-short')
        }
        if (!$('#section-welcome').isInViewport()) {
            $('#login-top-mobile, #login-top-desktop').addClass('position-fixed');
            $('#login-top-mobile, #login-top-desktop').addClass('bg-black');
        } else {
            $('#login-top-mobile, #login-top-desktop').removeClass('position-fixed');
            $('#login-top-mobile, #login-top-desktop').removeClass('bg-black');
        }

        setActiveSection();
    });

    function setActiveSection() {
        $('.home-section').each(function (idx, section) {
            if ($(section).isInMainViewport()) {
                let id = $(this).attr('id');
                $('.btn-top-white').removeClass('active');
                $(`a[data-section-target='${id}']`).addClass('active');

                $('#mobile-menu-items a').removeClass('active');
                $(`a[data-section-target='${id}']`).addClass('active');

                return false;
            }
        })
    }

    $(document).on('submit', '#contact-form', function (e) {
        $('#btn-submit-contact').attr('disabled', true);
        let formData = $(this).serializeArray();
        $.ajax({
            type: 'POST',
            url: '/contact/send',
            data: formData,
            success: function (response) {
                $('#section-contact').replaceWith(response)
            },
            error: function () {
                alert('Error sending contact')
            }
        });

        e.preventDefault();
        return false;
    })

    $('#top-mobile-btn-menu').click(function () {
        $('#mobile-menu').modal('show');
    })
    $('#mobile-menu-items a').click(function () {
        $('#mobile-menu').modal('hide');
    })


    function submitAuthForm(formId, responseContainer, buttonId, redirectContainer) {
        var $formSubmitBtn = $(formId + ' button[type=submit]');
        $formSubmitBtn.attr('disabled', true);
        var $buttonText = $(buttonId).text()
        var href = $(formId).attr('action');
        const applyRedirect = /*responseContainer.indexOf('#home-register-modal') !== -1 ||*/
            responseContainer.indexOf('#home-login-modal') !== -1;
        var formData = $(formId).serializeArray();

        $.ajax({
            type: 'POST',
            url: href,
            data: formData,
            headers: {
                'X-PJAX': true,
            },
            beforeSend: function () {
                window.helpers.buttonLoader({status: 'loading', button: buttonId, buttonText: $buttonText});
            },

            success: function (response) {
                if (applyRedirect || response.indexOf('window.location') !== -1) {
                    $('.form-control').removeClass('is-invalid');
                    window.helpers.buttonLoader({status: 'checked', button: buttonId, buttonText: ''});
                    $(redirectContainer).html(response);
                } else if (formId !== '#formResendVerification') {
                    $(responseContainer).html(response)
                } else if (formId === '#formResendVerification') {
                    $(buttonId).addClass('text-decoration-none');
                    window.helpers.buttonLoader({status: 'checked', button: buttonId, buttonText: ''});
                    setTimeout(function () {
                        $('.auth-modal').modal('hide')
                    }, 1000)
                }
            },

            error: function (error) {
                $(responseContainer).html(error.responseText)
                window.helpers.buttonLoader({status: 'default', button: buttonId, buttonText: $buttonText});
                $formSubmitBtn.removeAttr('disabled');
            }
        });
    }
});

$.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

$.fn.isInMainViewport = function () {
    var elementTop = $(this).offset().top - 300;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};
